<template>
  <transition name="el-fade-in">
    <div class="page-up row-space-center row-direction" @click="scrollToTop" v-show="toTopShow">
      <img src="@/assets/to_top_image1.png" style="width:120px"/>
      <div class="mt-4" style="color: rgb(50 136 178);font-weight:700;margin-top:-32px;">回到顶部</div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      toTopShow: false,
      showBackToTop:false,
      dom: null,
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.handleScroll, true)
    })
  },
  destroyed() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    goToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
    },
    handleScroll2() {
        console.log(window.pageYOffset)
      // 根据滚动位置决定是否显示回到顶部按钮
      this.showBackToTop = window.pageYOffset > 200;
    },
    handleScroll() {
      this.dom = document.querySelector('.container')
      this.scrollTop = this.dom.scrollTop
      if (this.scrollTop > 300) {
        this.toTopShow = true
      } else {
        this.toTopShow = false
      }
    },
    scrollToTop() {
      let timer = null
      let _this = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 5000) {
          _this.scrollTop -= 1000
          _this.dom.scrollTop = _this.scrollTop
          timer = requestAnimationFrame(fn)
        } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
          _this.scrollTop -= 500
          _this.dom.scrollTop = _this.scrollTop
          timer = requestAnimationFrame(fn)
        } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
          _this.scrollTop -= 100
          _this.dom.scrollTop = _this.scrollTop
          timer = requestAnimationFrame(fn)
        } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
          _this.scrollTop -= 10
          _this.dom.scrollTop = _this.scrollTop
          timer = requestAnimationFrame(fn)
        } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
          _this.scrollTop -= 5
          _this.dom.scrollTop = _this.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _this.toTopShow = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-up {
//   background-color: #409eff;
  position: fixed;
  right: 0px;
  bottom: 40px;
  cursor: pointer;
  transition: 0.3s;
//   opacity: 0.5;
  z-index: 100;
  .el-icon-caret-top {
    color: #fff;
    display: block;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
  }
  p {
    display: none;
    text-align: center;
    color: #fff;
  }
  &:hover {
    opacity: 1;
  }
}
</style>
